module.exports = __webpack_public_path__ + "static/media/logoEasyvoteBlue1@3x.954b1918.png";